export const ADMIN_PAGE_TITLE = `Панель администратора. `

export const MAIN_ADMIN_PANEL_TITLE = `Панель администратора`

export const ADMIN_PANEL_MODER = `Секция модератора (модификации)`

export const ADMIN_PANEL_SUPPORT = `Центр поддержки пользователей`

export const ADMIN_PANEL_COMMENTS = `Комментарии на сайте`

export const ADMIN_PANEL_USERS = `Пользователи сайта`

export const ADMIN_PANEL_LINKER = {
    MAIN: 'Панель администратора',
    MODER: ADMIN_PANEL_MODER,
    SUPPORT: ADMIN_PANEL_SUPPORT,
    COMMENTS: ADMIN_PANEL_COMMENTS,
    USERS: ADMIN_PANEL_USERS
}

export const ADMIN_PANEL = [
    {
        id: 1,
        category: ADMIN_PANEL_LINKER.MODER,
        url: "/mods/",
        img: `https://tankimods.net/documents/img/mod_.png`, // https://cdn-kbms.gcdn.co/documents/account_management_fsQapEL.svg
    }, 
    {
        id: 2,
        category: ADMIN_PANEL_LINKER.SUPPORT,
        url: "/support/",
        img: `https://tankimods.net/documents/img/call-center.png`, // https://cdn-kbms.gcdn.co/documents/technical_issues_Iiyfaab.svg
    }, 
    {
        id: 3,
        category: ADMIN_PANEL_LINKER.COMMENTS,
        url: "/comments/",
        img: `https://tankimods.net/documents/img/comment.png`, // https://cdn-kbms.gcdn.co/documents/technical_issues_Iiyfaab.svg
    }, 
    {
        id: 4,
        category: ADMIN_PANEL_LINKER.USERS,
        url: "/users/",
        img: `https://tankimods.net/documents/img/group__.png`, // https://cdn-kbms.gcdn.co/documents/technical_issues_Iiyfaab.svg
    }
]

export const ADMIN_PANEL_LINKES = (page) => {
    if (page === 'admin-panel') {
        return ADMIN_PANEL_LINKER.MAIN
    } else if (page === 'mods') {
        return ADMIN_PANEL_LINKER.MODER
    } else if (page === 'support') {
        return ADMIN_PANEL_LINKER.SUPPORT
    } else if (page === 'comments') {
        return ADMIN_PANEL_LINKER.COMMENTS
    } else if (page === 'users') {
        return ADMIN_PANEL_LINKER.USERS
    }
}

export const ADMIN_PANEL_MODER_TITLE = `Панель модератора`

export const ADMIN_PANEL_UNAUTHORIZED_MESSAGE = `Данный раздел недоступен`

export const ADMIN_PANEL_LOGIN = `Sign In`
